var exports = {
  "Qs": "BanMemberModal.module__content___Mm10M3",
  "Ki": "BanMemberModal.module__video___Mm10M3",
  "Gf": "BanMemberModal.module__sectionTitle___Mm10M3",
};

module.exports = exports;
